import { render, staticRenderFns } from "./Receiving.vue?vue&type=template&id=a4c3b50e&scoped=true&"
import script from "./Receiving.vue?vue&type=script&lang=js&"
export * from "./Receiving.vue?vue&type=script&lang=js&"
import style0 from "./Receiving.vue?vue&type=style&index=0&id=a4c3b50e&prod&lang=css&"
import style1 from "./Receiving.vue?vue&type=style&index=1&id=a4c3b50e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c3b50e",
  null
  
)

export default component.exports